// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1667":"b7f7e2f11f5ab5a9","2293":"b730da168e935c4b","5398":"c108d5bbca6b0a25"}[chunkId] + ".css";
};